<mat-dialog-content data-testid="sbar-history-dialog">
  <div class="modal-header">
    <h4 class="modal-title pull-left">SBAR History</h4><i class="fas fa-times pull-right fontL3 ml-3" (click)="hideModal()"></i>
  </div>
  <div class="modal-body">
    <div class="col-xs-12 flex bold fontL">
      <span class="col-xs-2 pr-1">situation</span>
      <span class="col-xs-3 pr-1">background</span>
      <span class="col-xs-2 pr-1">assessment</span>
      <span class="col-xs-2 pr-1">recommendation</span>
      <span class="col-xs-1 pr-1">category</span>
      <span class="col-xs-2 pr-1">createdBy</span>
      <span class="col-xs-1 pr-1">createdAt</span>
    </div>
    <div class="col-xs-12 flex bdr-btm" *ngFor="let sbar of sbarHistory">
      <span class="col-xs-2 overflow-wrap pr-1">{{sbar.get('situation')}}</span>
      <span class="col-xs-3 overflow-wrap pr-1">{{sbar.get('background')}}</span>
      <span class="col-xs-2 overflow-wrap pr-1">{{sbar.get('assessment')}}</span>
      <span class="col-xs-2 overflow-wrap pr-1">{{sbar.get('recommendation')}}</span>
      <span class="col-xs-1 overflow-wrap pr-1">{{sbar.get('category')}}</span>
      <span class="col-xs-2 clr-link overflow-wrap pr-1" *ngIf="sbar.get('createdBy')">{{sbar.get('createdBy')?.get('username')}}</span>
      <span class="col-xs-1 overflow-wrap pr-1" >{{sbar.get('createdAt') | amDateFormat: 'DD/MM/YYYY'}}</span>
    </div>
  </div>
</mat-dialog-content>
